.root {
  position: sticky;
  top: 0;
  z-index: var(--z-index-low);
  width: 100%;
  padding-right: 17px;
  padding-left: 17px;
  background-color: #fff;
  border-bottom: 1px solid rgb(0 0 0 / 12%);
  transition: opacity 0.5s linear;

  &[data-is-preview='true'] {
    top: 64px;
  }

  &[data-is-folded='true'] {
    pointer-events: none;
    opacity: 0;
  }
}

.inner {
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1126px;
  min-height: 56px;
  margin: auto;
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    gap: 70px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    gap: 70px;
  }
}
